import React from 'react'

const EditLabelModal = ({labelId, handleClose, handleSubmit }) => {


    return (
        <>
        </>
    )
}

export default EditLabelModal